"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SvgIcon = exports.SvgIcon = function SvgIcon(_ref) {
  var name = _ref.name,
    color = _ref.color,
    className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: "https://jl-money-static-assets-prod.storage.googleapis.com/icons/".concat(name, "-").concat(color, ".svg"),
    alt: "",
    "data-icon-name": name,
    "data-icon-colour": color,
    className: className,
    role: "img"
  });
};
var _default = exports["default"] = SvgIcon;